module.exports = [{"continent":"Europe","countries":[{"id":"fr","name":"France","lang":"fr","colorSet":1},{"id":"be_fr","name":"Belgium (fr)","lang":"fr","colorSet":2},{"id":"be_nl","name":"Belgium (nl)","lang":"nl","colorSet":2},{"id":"nl","name":"Netherlands","lang":"nl","colorSet":2},{"id":"it","name":"Italy","lang":"it","colorSet":4}]},{"continent":"Asia","countries":[{"id":"cn","name":"China","lang":"cn","colorSet":1},{"id":"in","name":"India","lang":"en","colorSet":3}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/regions.json
// module id = 36
// module chunks = 0